import type {CSSProperties} from 'react';

export type WedgeTodaySheetLook = 'today-btn' | 'today-ic' | 'today-qa' | 'today-fig' | 'today-mtg' | 'today-chip' | 'today-link';

const TODAY_SHEET_LOOKS = new Set<string>(['today-btn', 'today-ic', 'today-qa', 'today-fig', 'today-mtg', 'today-chip', 'today-link']);
export const isWedgeTodaySheetLook = (look: string): look is WedgeTodaySheetLook => TODAY_SHEET_LOOKS.has(look);

/* Released controls of the Today field sheet (status readout, hero, day rail, figures, capture dock). The sheet paints every control from its
   own scoped stylesheet through the classes `btn`, `ic`, `qa`, `fig`, `mtg`, `mtg-chip` and `tour-link`, with their hover, press, focus and
   narrow-width rules. The caller keeps the class, so a look holds nothing: any inline value here would beat a class rule and change the box.
   No look draws a transparent target and none anchors the button: the pins of the rail sit absolute at a percent of the track, the figures
   and the chips are flush with their neighbors, and an anchor would move how the rail resolves its children (wedgeTodaySheetDrawsHit). */
export const wedgeTodaySheetDrawsHit = (look: string): boolean => !isWedgeTodaySheetLook(look);

export function wedgeTodaySheetStyle(_look: WedgeTodaySheetLook): CSSProperties {
  return {};
}

export type WedgeTodayFieldVariant = 'wedge-today-log-field';
export const isWedgeTodayFieldVariant = (variant: unknown): variant is WedgeTodayFieldVariant => variant === 'wedge-today-log-field';

/* The log-a-visit search box of the capture dock: one bare native search input inside the sheet's `inp` pill. The pill classes paint the
   input (flex, 17px type, no border, a transparent fill and the muted placeholder), so the variant holds no inline value. */
export function wedgeTodayFieldStyle(_variant: WedgeTodayFieldVariant): CSSProperties {
  return {};
}
